/* Victoria London — cart drawer.
   Fetches /cart.js, renders line items + free-delivery meter, and handles
   qty changes via /cart/change.js. Opens from the header bag icon and
   after quick-add. Exposed as window.vlCartDrawer. */
(function () {
  var THRESHOLD = 1999; // free next-day delivery (Royal Mail 24) from £19.99 in pence, mirrors the Shopify rate condition
  var root, itemsEl, countEl, subtotalEl, shipMsgEl, shipBarEl, savedEl, noteEl;
  var busy = false;

  function money(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function render(cart) {
    countEl.textContent = cart.item_count;

    // Shopify applies /discount codes to the cart itself, so show what the
    // customer will actually pay and call out the saving, or the drawer
    // contradicts the discounted prices shown on the product pages.
    subtotalEl.textContent = money(cart.total_price);
    if (savedEl) {
      if (cart.total_discount > 0) {
        var codes = (cart.cart_level_discount_applications || [])
          .map(function (a) { return a.title; }).filter(Boolean).join(', ');
        savedEl.textContent = 'You saved ' + money(cart.total_discount) + (codes ? ' with ' + codes : '');
        savedEl.hidden = false;
      } else {
        savedEl.hidden = true;
      }
    }
    if (noteEl) {
      noteEl.textContent = cart.total_discount > 0
        ? 'Shipping is calculated at checkout.'
        : 'Shipping and any discounts are calculated at checkout.';
    }

    // Shipping rate conditions apply to the discounted total, and Shopify now
    // applies /discount codes to the cart itself, so meter off total_price.
    var meterTotal = cart.total_price;

    if (meterTotal >= THRESHOLD) {
      shipMsgEl.innerHTML = '<strong>Free Next Day Delivery unlocked.</strong> Delivered by Royal Mail 24.';
      shipBarEl.style.width = '100%';
    } else {
      var away = THRESHOLD - meterTotal;
      shipMsgEl.innerHTML = 'You’re <strong>' + money(away) + '</strong> away from Free Next Day Delivery.';
      shipBarEl.style.width = Math.max(4, Math.round(meterTotal / THRESHOLD * 100)) + '%';
    }

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="vl-cd__empty">Your bag is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      // line_price carries cart-applied code discounts, final_line_price carries
      // line-level ones; the lower of the two is what the customer pays.
      var lineOriginal = item.original_line_price != null ? item.original_line_price : item.price * item.quantity;
      var lineNow = Math.min(
        item.final_line_price != null ? item.final_line_price : lineOriginal,
        item.line_price != null ? item.line_price : lineOriginal
      );
      var priceHtml = lineNow < lineOriginal
        ? '<strong>' + money(lineNow) + '</strong><s>' + money(lineOriginal) + '</s>'
        : money(lineNow);
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !item.properties[k]) return;
          props += '<p class="vl-cd__item-variant">' + esc(k) + ': ' + esc(item.properties[k]) + '</p>';
        });
      }
      return '<div class="vl-cd__item" data-line="' + (i + 1) + '">' +
        (img ? '<img class="vl-cd__item-img" src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '') +
        '<div class="vl-cd__item-body">' +
          '<div class="vl-cd__item-top">' +
            '<a class="vl-cd__item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            '<span class="vl-cd__item-price">' + priceHtml + '</span>' +
          '</div>' +
          (variant ? '<p class="vl-cd__item-variant">' + esc(variant) + '</p>' : '') +
          props +
          '<div class="vl-cd__item-controls">' +
            '<span class="vl-cd__qty">' +
              '<button type="button" data-vl-cd-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-vl-cd-qty="1" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<button type="button" class="vl-cd__remove" data-vl-cd-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function open() {
    root.classList.add('vl-cd--open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vl-cd-lock');
  }

  function close() {
    root.classList.remove('vl-cd--open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vl-cd-lock');
  }

  function changeLine(line, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        var headerCart = document.querySelector('.cart.utils__item');
        if (headerCart) headerCart.classList.toggle('cart--show-indicator', cart.item_count > 0);
      })
      .finally(function () { busy = false; });
  }

  function init() {
    root = document.getElementById('vl-cart-drawer');
    if (!root) return;
    itemsEl = root.querySelector('[data-vl-cd-items]');
    countEl = root.querySelector('[data-vl-cd-count]');
    subtotalEl = root.querySelector('[data-vl-cd-subtotal]');
    shipMsgEl = root.querySelector('[data-vl-cd-ship]');
    shipBarEl = root.querySelector('[data-vl-cd-bar]');
    savedEl = root.querySelector('[data-vl-cd-saved]');
    noteEl = root.querySelector('[data-vl-cd-note]');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-vl-cd-close]')) { close(); return; }
      var qtyBtn = e.target.closest('[data-vl-cd-qty]');
      var removeBtn = e.target.closest('[data-vl-cd-remove]');
      var itemEl = e.target.closest('.vl-cd__item');
      if (!itemEl) return;
      var line = Number(itemEl.getAttribute('data-line'));
      if (qtyBtn) {
        var current = Number(itemEl.querySelector('.vl-cd__qty span').textContent);
        changeLine(line, Math.max(0, current + Number(qtyBtn.getAttribute('data-vl-cd-qty'))));
      } else if (removeBtn) {
        changeLine(line, 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('vl-cd--open')) close();
    });

    // Header bag icon opens the drawer everywhere except the cart page itself
    if (!document.body.classList.contains('template-cart')) {
      document.addEventListener('click', function (e) {
        var link = e.target.closest('.cart.utils__item a');
        if (!link) return;
        e.preventDefault();
        refresh().then(open);
      });
    }

    // PDP add-to-bag: stay on the page and open the drawer.
    // Subscription (selling plan) purchases keep the theme's checkout flow.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      var plan = form.querySelector('[name="selling_plan"]');
      if (plan && plan.value) return;
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        var headerCart = document.querySelector('.cart.utils__item');
        if (headerCart) headerCart.classList.add('cart--show-indicator');
        return refresh().then(open);
      }).catch(function () {
        window.location.href = '/cart';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.vlCartDrawer = {
    open: function () { refresh().then(open); },
    close: close,
    refresh: refresh
  };
})();
